"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const app_1 = __importDefault(require("../app"));
class BootstrapTabs {
    // eslint-disable-next-line class-methods-use-this
    init() {
        const locationHash = window.location.hash;
        if (!locationHash || locationHash === "#") {
            return;
        }
        const selectedTab = (0, jquery_1.default)(`.nav-tabs a[href="${locationHash}"]`);
        if (selectedTab.length !== 1) {
            return;
        }
        selectedTab.tab("show");
    }
}
exports.default = BootstrapTabs;
app_1.default.loadAndRegister("BootstrapTabs", () => new BootstrapTabs());
